<template>
  <t-text-input
    ref="field"
    v-bind="$attrs"
    mask="(##) #####-####"
    :label="noLabel ? '' : label"
    :rules="validationRules"
    :model-value="modelValue"
    type="text"
  />
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from "vue";
import { ValidationRule } from "vuetify";
import TTextInput from "@/components/core/TTextInput.vue";
import { VTextField } from "vuetify/components";

interface Props {
  noLabel?: boolean;
  label?: string;
  rules?: ValidationRule[];
  modelValue?: string | null;
}

const {
  noLabel = false,
  label = "Fone",
  rules = [],
  modelValue = null,
} = defineProps<Props>();

defineOptions({
  name: "TPhoneInput",
  inheritAttrs: false,
});

const field = useTemplateRef<VTextField>("field");

function getPhoneNumbers(phone?: string | null): string {
  const regex = /[\d]/g;
  return phone?.match(regex)?.join("") ?? "";
}

const validationRules = computed<ValidationRule[]>(() => {
  const validatePhone = (phone?: string): boolean | string => {
    const phoneLength = getPhoneNumbers(phone).length;
    return phoneLength === 11 || "O número de telefone deve conter no mínimo 11 dígitos";
  };

  return [...rules, validatePhone];
});

function validate(): Promise<boolean | string[]> {
  if (!field.value) return Promise.resolve(false);

  return field.value.validate();
}

defineExpose({
  validate,
});
</script>
